import { render, staticRenderFns } from "./PageMathGameScore.vue?vue&type=template&id=0e530f1a&scoped=true&"
import script from "./PageMathGameScore.vue?vue&type=script&lang=js&"
export * from "./PageMathGameScore.vue?vue&type=script&lang=js&"
import style0 from "./PageMathGameScore.vue?vue&type=style&index=0&id=0e530f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e530f1a",
  null
  
)

export default component.exports